<button
  class="category-button category-button--{{type}}"
  [disabled]="disabled"
  [ngClass]="{ 'category-button--opened': opened, 'category-button--disabled': disabled }"
>
  <ng-container *ngIf="!opened && productsAdded > 0">
    <mfp-bubble
      class="category-button__products-bubble"
      size="small"
      [label]="productsAdded.toString()"
      [fill]="type === 'protection' ? 'clear' : 'filled'"
      [disabled]="disabled"
    ></mfp-bubble>
  </ng-container>

  <ng-container *ngIf="icon">
    <img
      class="category-button__icon"
      alt="Button icon"
      mfpLazyImage
      [lazySrc]="icon"
    >
  </ng-container>
  <div class="category-button__text-container">
    <span
      class="category-button__label"
      [ngClass]="{ 'category-button__label--ellipsis': !opened }"
    >{{ label | translate }}</span>
    <ng-container *ngIf="opened">
      <ng-container *ngIf="type === 'protection' && productsAdded === 0">
        <div class="category-button__advice">
          <span class="category-button__advice__label category-button__advice__label--subdued">
            {{ 'MENU.LIFE_PLAN.PRODUCTS.NO_PRODUCTS_ADDED' | translate }}
          </span>
        </div>
      </ng-container>
      <ng-container *ngIf="type === 'protection' && productsAdded > 0">
        <ng-container *ngIf="productsAdded === totalProducts">
          <div class="category-button__advice">
            <span class="category-button__advice__label">
              {{ (productsAdded === 1 ? 'MENU.LIFE_PLAN.PRODUCTS.SINGLE_PRODUCT_ADDED' : 'MENU.LIFE_PLAN.PRODUCTS.MULTIPLE_PRODUCTS_ADDED') | translate: {products: productsAdded} }}
            </span>
            <span class="category-button__advice__label category-button__advice__label--strong">
              {{ 'MENU.LIFE_PLAN.PRODUCTS.FINANCIAL_HEALTH_POINTS' | translate: {points: healthPoints > 0 ? '+' + healthPoints : healthPoints} }}
            </span>
          </div>
        </ng-container>
        <ng-container *ngIf="productsAdded < totalProducts">
          <div class="category-button__advice">
            <span class="category-button__advice__label">
              {{ 'MENU.LIFE_PLAN.PRODUCTS.SOME_OF_MULTIPLE_PRODUCTS_ADDED' | translate: {products: productsAdded, total: totalProducts} }}
            </span>
            <span class="category-button__advice__label category-button__advice__label--strong">
              {{ 'MENU.LIFE_PLAN.PRODUCTS.FINANCIAL_HEALTH_POINTS' | translate: {points: healthPoints > 0 ? '+' + healthPoints : healthPoints} }}
            </span>
          </div>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="type === 'cart'">
        <div class="category-button__advice">
          <span class="category-button__advice__label">
            {{ (productsAdded === 1 ? 'MENU.LIFE_PLAN.PRODUCTS.SINGLE_PRODUCT_ADDED' : 'MENU.LIFE_PLAN.PRODUCTS.MULTIPLE_PRODUCTS_ADDED') | translate: {products: productsAdded} }}
          </span>
        </div>
        <div class="category-button__advice">
          <span class="category-button__advice__label">
            {{ 'MENU.LIFE_PLAN.PRODUCTS.FINANCIAL_HEALTH' | translate: {products: productsAdded, total: totalProducts} }}
          </span>
          <span class="category-button__advice__label category-button__advice__label--strong">
            {{ 'MENU.LIFE_PLAN.PRODUCTS.TOTAL_FINANCIAL_HEALTH_POINTS' | translate: {points: healthPoints} }}
          </span>
        </div>
      </ng-container>
    </ng-container>
  </div>
</button>
